<form [formGroup]="form" class="phone-number-input" [class.phone-number-input--invalid]="invalid()">
  <div class="flex flex-column gap-2 w-full">
    @if (label(); as labelText) {
      <div>
        <label [attr.for]="inputId() ?? 'combinedValue'" class="text-xs number-label">{{ labelText }}</label>
      </div>
    }
    <div class="p-inputgroup">
      <span class="p-inputgroup-addon p-inputtext-sm">
        <p-select
          formControlName="prefix"
          [options]="countryCodes"
          [filter]="true"
          filterBy="label"
          [virtualScroll]="true"
          [virtualScrollItemSize]="15"
          [invalid]="invalid()">
          <ng-template #selectedItem>
            @if (selectedCountry(); as country) {
              <div class="flex align-items-center gap-3">
                <img
                  [src]="'/assets/shared-ui/img/flags/' + country.countryCode.toLowerCase() + '.svg'"
                  [alt]="country.countryCode.toLowerCase()"
                  style="width: 1.125rem" />
                <div class="text-sm">{{ country.value }}</div>
              </div>
            }
          </ng-template>
          <ng-template #item let-country>
            <div class="flex align-items-center gap-3">
              <img
                [src]="'/assets/shared-ui/img/flags/' + country.countryCode.toLowerCase() + '.svg'"
                [alt]="country.countryCode.toLowerCase()"
                style="width: 1.125rem" />
              <div class="text-sm">
                {{ country.countryCode }}
                <span style="color: var(--status-gray)">{{ country.value }}</span>
              </div>
            </div>
          </ng-template>
        </p-select>
      </span>
      <input
        formControlName="number"
        [id]="inputId() ?? 'combinedValue'"
        type="tel"
        pInputText
        [invalid]="invalid()"
        [attr.aria-invalid]="invalid() ? true : null"
        [attr.aria-describedby]="ariaDescribedBy() ?? null"
        (paste)="onPaste($event)"
        (blur)="onBlur()"
        [placeholder]="placeholder()" />
    </div>
  </div>
</form>
